var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolsStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8333 27.4997C33.275 27.4997 31.969 26.9729 30.9155 25.9193C29.8619 24.8658 29.3345 23.5592 29.3333 21.9997C29.3333 20.4413 29.8607 19.1354 30.9155 18.0818C31.9703 17.0283 33.2762 16.5009 34.8333 16.4997C36.3917 16.4997 37.6982 17.0271 38.753 18.0818C39.8078 19.1366 40.3345 20.4426 40.3333 21.9997C40.3333 23.558 39.8065 24.8646 38.753 25.9193C37.6994 26.9741 36.3929 27.5009 34.8333 27.4997ZM16.5 31.1663L13.9333 28.5538L18.6542 23.833H3.66666V20.1663H18.6542L13.9333 15.3997L16.5 12.833L25.6667 21.9997L16.5 31.1663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolsStep);
export default __webpack_public_path__ + "static/media/symbols_step.dc3f1648881b68e5991fb3f6cc465b44.svg";
export { ForwardRef as ReactComponent };